// customer服务器，文档参考：https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=20618658
export const HOST = [
    'https://ams-account-us-test.tigerbrokers.net',
    'https://account.tradeup.com',
    // 如果需要使用qa环境, 在这里把数字做一个调整,改成对应的环境
    'https://ams-account-us-test.tigerbrokers.net'
];
export const API = {
    // https://apidocs.tigerfintech.com/repository/39/api/master/reference/app-web.json#/operations/get-api-v1-account-infos @jianjun
    getAccountInfos: '/account/api/v1/syep/supported-accounts' // 获取账户信息列表
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    const cfg = CG_API.account;

    if (cfg) {
        cfg.COMMON && HOST.fill(cfg.COMMON);
    }
}
